import api from '@edu-fe/api'

export default {
  name: 'wealth',
  getWealthData: (courseId = '') => api.create(`/money/total?courseId=${courseId}`),
  getWealthDetailData: api.create('/money/detail'),
  getInvitationCourse: api.create('/course/distributions'),
  getCourseData: api.create('/popular/courses'),
  drawMoney: api.create('/my/withdraw'),
  share: api.create('/popular/share'),
  getWealthStatus: api.create('/my/identity/status'),
  getCibaCourse: api.create('/knowledge/search/courses')
}
